const SVGUnchecked = () => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='radio_button_unchecked'>
        <mask id='mask0_141_5151' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='25'>
          <rect id='Bounding box' y='0.624756' width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_141_5151)'>
          <path
            id='radio_button_unchecked_2'
            d='M12 22.6248C10.6167 22.6248 9.31667 22.3623 8.1 21.8373C6.88333 21.3123 5.825 20.5998 4.925 19.6998C4.025 18.7998 3.3125 17.7414 2.7875 16.5248C2.2625 15.3081 2 14.0081 2 12.6248C2 11.2414 2.2625 9.94142 2.7875 8.72476C3.3125 7.50809 4.025 6.44976 4.925 5.54976C5.825 4.64976 6.88333 3.93726 8.1 3.41226C9.31667 2.88726 10.6167 2.62476 12 2.62476C13.3833 2.62476 14.6833 2.88726 15.9 3.41226C17.1167 3.93726 18.175 4.64976 19.075 5.54976C19.975 6.44976 20.6875 7.50809 21.2125 8.72476C21.7375 9.94142 22 11.2414 22 12.6248C22 14.0081 21.7375 15.3081 21.2125 16.5248C20.6875 17.7414 19.975 18.7998 19.075 19.6998C18.175 20.5998 17.1167 21.3123 15.9 21.8373C14.6833 22.3623 13.3833 22.6248 12 22.6248ZM12 20.6248C14.2333 20.6248 16.125 19.8498 17.675 18.2998C19.225 16.7498 20 14.8581 20 12.6248C20 10.3914 19.225 8.49976 17.675 6.94976C16.125 5.39976 14.2333 4.62476 12 4.62476C9.76667 4.62476 7.875 5.39976 6.325 6.94976C4.775 8.49976 4 10.3914 4 12.6248C4 14.8581 4.775 16.7498 6.325 18.2998C7.875 19.8498 9.76667 20.6248 12 20.6248Z'
            fill='#C2C7D0'
          />
        </g>
      </g>
    </svg>
  );
};

export default SVGUnchecked;
